<script setup>
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
const route = useRoute()
const { data: riverList } = await useRiverList()
const riverInfo = computed(() => riverList.value?.find((r) => r.code === route.params.river))
const prefText = computed(() => {
  return riverInfo.value.pref.split(',')
    .filter(Boolean)
    .map((p) => p.replace(/[都府県]$/, ''))
    .join('・')
})
if (!riverInfo.value) {
  throw createError({
    statusCode: 404,
    statusMessage: 'River System Page Not Found'
  })
}
const breadCrumbList = isWebViewFlag ? [] : getBreadCrumb('river', riverInfo.value.name)
useCustomMeta('river', riverInfo.value.name, prefText.value)
const { data: pointList } = await useAsyncData(
  `river-point-list-${route.params.river}`,
  () => $fetch('/api/river/list/pointlist', {
    query: {
      path: route.params.river
    }
  }),
  { watch: [() => route.params.river] }
)
</script>

<template>
  <div>
    <NuxtLayout
      name="custom"
      :bread-crumb-list="breadCrumbList"
    >
      <div class="frame">
        <CommonPageTitle :title="`${riverInfo.name}の河川水位情報（${prefText}）`" />
        <RiverFocusMap :point-list="pointList" />
      </div>
      <template #main-bottom>
        <RiverCameraList :page-info="riverInfo" />
        <RiverSearch />
        <HorizontalStackAd
          v-if="!isWebViewFlag"
          left-ad-id="ads-btf2-left-pc"
          right-ad-id="ads-btf2-right-pc"
        />
        <div
          id="ads-btf1-sp"
          class="ads-btf1-sp"
        />
        <TopicList />
      </template>
    </NuxtLayout>
  </div>
</template>

<style lang="scss" scoped>
.frame {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.ads-btf1-sp {
  min-height: 50px;
  text-align: center;
  margin: 0px auto;
  position: relative;
}
</style>
